/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateConsentDecisionRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {ConsentDecisionResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const updateConsentDecision = (request: UpdateConsentDecisionRequest, options?: CashRequestOptions) => post<UpdateConsentDecisionRequest, ConsentDecisionResponse>("/2.0/cash/update-consent-decision", request, {...options, rejectOnError: true })